export default __webpack_public_path__ + "static/media/fpb51000.a11cf925.png";